import { Button } from "antd";
import { useNavigate } from "react-router-dom";

interface PropsType {
  proposalId: string;
  dealId: string;
  companyId: string;
}

export default function Accepted(props: PropsType) {
  const { proposalId, dealId, companyId } = props;
  const navigate = useNavigate();
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #B9ECDE99", backgroundColor: "#ECF8F2" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/accepted.svg" alt="" />
        <Button
          htmlType="button"
          className="mint-btn btn-sm"
          type="primary"
          onClick={() =>
            navigate(`/sent-to-production/${proposalId}/${dealId}/${companyId}`)
          }
          style={{ backgroundColor: "#00A07D" }}
        >
          Send to production
        </Button>
      </div>
      <h5>
        Status:{" "}
        <span style={{ color: "#00A07D", fontWeight: "700" }}>Accepted</span>
      </h5>
      <h6
        style={{
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
        }}
      >
        The customer approved this proposal.
      </h6>
    </div>
  );
}
